<div class="new-analytics__datepicker-container">
  <h2>Analytics</h2>
  <div class="new-analytics__datepicker">
    <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
    <app-custom-datepicker
      variant="form"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [startDate]="startDate"
      [endDate]="endDate"
      (changeDateRange)="setDateRangeValue($event)"></app-custom-datepicker>
  </div>
</div>
<div id="analytics-container" class="new-analytics__content">
  @if (loading) {
    <div>
      <app-main-loader-lottie> </app-main-loader-lottie>
    </div>
  }
  @if (notFoundMsg) {
    <div class="new-analytics__not_found">
      <span class="new-analytics__not_found__err_msg">{{ notFoundMsg }}</span>
    </div>
  }
</div>
